import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.32);
  backdrop-filter: blur(2px);
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1301;
  width: 90vw;
  height: 90vh;
  max-width: 1440px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.16);
  animation: ${slideUp} 0.25s ease-out;
`;

export const MainPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 32px 16px;
  flex-shrink: 0;
`;

export const HeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 32px 16px;
  flex-shrink: 0;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  max-width: 360px;
`;

export const ViewToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.xs};
  margin-left: auto;
  background: ${(props) => props.theme.colors.ghostWhite};
  border-radius: 8px;
  padding: 2px;
`;


export const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const WidgetGrid = styled.div`
  padding: 0 32px 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${(props) => props.theme.spacing.md};
  align-content: start;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
  padding: 16px 32px;
  flex-shrink: 0;
`;

export const SelectionAlertWrap = styled.div`
  [role='alert'] {
    animation: none !important;
  }
`;

export const ModalFooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const EmptyStateContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 32px;
  color: ${(props) => props.theme.colors.davysGrey};
`;

export const SkeletonGrid = styled.div`
  padding: 0 32px 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${(props) => props.theme.spacing.md};
  align-content: start;
`;
